import { Intent } from "@blueprintjs/core";
import DetailPaneCallout from "components/detailPane/shared/DetailPaneCallout";
import React from "react";
import "./PilCallout.scss";

type PilCalloutProps = {
    readonly plannedMw: number | undefined;
};

// Today only SPP has PILs; when other regions adopt the concept, the framing
// copy below will likely need to become region-configurable.
const PilCallout: React.FC<PilCalloutProps> = ({ plannedMw }) => {
    if (plannedMw === undefined) {
        return (
            <DetailPaneCallout
                className="PilCallout"
                intent={Intent.WARNING}
                title="Unplanned Interconnection Location"
            >
                This location is not on SPP&apos;s planned interconnection list.
                Developers are subject to full DAUC costs for all triggered
                constraints, in addition to the GRID&#8209;C charge.
            </DetailPaneCallout>
        );
    }

    return (
        <DetailPaneCallout
            className="PilCallout"
            intent={Intent.PRIMARY}
            title={`SPP Planned MW: ${plannedMw.toLocaleString()}`}
        >
            This location is designated as a Planned Interconnection Location
            (PIL) under SPP&apos;s Consolidated Planning Process.
        </DetailPaneCallout>
    );
};

export default PilCallout;
